import script from "./Classify.vue?vue&type=script&setup=true&lang=js"
export * from "./Classify.vue?vue&type=script&setup=true&lang=js"

import "./Classify.vue?vue&type=style&index=0&id=65af256c&lang=css"

const __exports__ = script;

export default __exports__